// extracted by mini-css-extract-plugin
export default {"messageBubble":"i_E2E0","text":"RzPL5P"};